import { z } from 'zod';
import { richTextSchema } from './rich-text';
export const inboxContext = z.object({
  type: z.enum(['client', 'task', 'request', 'project']),
  id: z.uuid(),
  channel: z.enum(['client', 'internal']).default('client'),
});
export const inboxThreadDto = z.object({
  id: z.uuid(),
  title: z.string(),
  contextType: z.enum(['client', 'task', 'request', 'project']),
  contextId: z.uuid(),
  channel: z.enum(['client', 'internal']),
  clientId: z.uuid().nullable(),
  clientName: z.string().nullable(),
  color: z.string(),
  projectId: z.uuid().nullable(),
  unread: z.number(),
  preview: z.string(),
  lastAt: z.string(),
});
export type InboxThreadDto = z.infer<typeof inboxThreadDto>;
export const inboxMessageDto = z.object({
  id: z.uuid(),
  body: richTextSchema,
  authorName: z.string(),
  mine: z.boolean(),
  createdAt: z.string(),
  editedAt: z.string().nullable(),
  deleted: z.boolean(),
  reply: z.object({ id: z.uuid(), authorName: z.string(), text: z.string() }).nullable(),
  files: z.array(z.object({ id: z.uuid(), name: z.string(), url: z.string() })),
  reactions: z.array(z.object({ emoji: z.string(), count: z.number(), mine: z.boolean() })),
});
export type InboxMessageDto = z.infer<typeof inboxMessageDto>;
export const inboxMessageInput = z.object({
  body: richTextSchema,
  replyToId: z.uuid().optional(),
  fileIds: z.array(z.uuid()).max(20).default([]),
  mentions: z.array(z.uuid()).max(30).default([]),
});
export const inboxPageDto = z.object({ messages: z.array(inboxMessageDto), next: z.string().nullable() });
